import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react'

import {getApiUrl} from '../utils/getApiUrl'
import {getAuthHeaders} from '../utils/getAuthHeaders'

export interface ChatSession {
  sessionId: string
  createdAt: string
  title: string
}

interface StartSessionResponse {
  sessionId: string
}

interface ListSessionsResponse {
  sessions: ChatSession[]
}

interface HistoryMessage {
  role: string
  content: string
}

interface LoadHistoryResponse {
  messages: HistoryMessage[]
}

export const chatApi = createApi({
  reducerPath: 'chatApi',
  baseQuery: fetchBaseQuery({
    baseUrl: getApiUrl(),
    prepareHeaders: async headers => {
      const authHeaders = await getAuthHeaders()
      Object.entries(authHeaders).forEach(([key, value]) => {
        headers.set(key, value)
      })
      return headers
    }
  }),
  endpoints: builder => ({
    startSession: builder.mutation<StartSessionResponse, void>({
      query: () => ({
        url: '/session/start',
        method: 'POST'
      })
    }),
    listSessions: builder.query<ListSessionsResponse, void>({
      query: () => '/session/list'
    }),
    loadHistory: builder.query<LoadHistoryResponse, string>({
      query: sessionId =>
        `/chat/history?sessionId=${encodeURIComponent(sessionId)}`
    }),
    submitFeedback: builder.mutation<
      {status: string},
      {spanId: string; traceId: string; rating: string}
    >({
      query: body => ({url: '/chat/feedback', method: 'POST', body})
    })
  })
})

export const {
  useStartSessionMutation,
  useLazyListSessionsQuery,
  useLazyLoadHistoryQuery,
  useSubmitFeedbackMutation
} = chatApi
